import React, {useContext, useState} from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Hidden from '@material-ui/core/Hidden'
import Menu from '@material-ui/icons/Menu'
import HeaderLinks from './HeaderLinks.jsx'
import Button from 'components/CustomButtons/Button.jsx'

import headerStyle from 'assets/jss/material-dashboard-react/components/headerStyle.jsx'
import {useLocation} from 'react-router-dom'
import {FormControl, Grid, MenuItem, TextField} from '@mui/material'
import {removeServiceWorker} from '../../utils/serviceWorker'
import {removeCookieByDomain} from '../../utils/cookie'
import config from 'config'
import dayjs from 'dayjs'
import {useSnackbar} from 'notistack'
import CustomSnackbar from '../CustomSnackbar/CustomSnackbar'
import {KMSessionUserContext} from '../../stores/KMSessionUserProvider'

function Header({...props}) {
    const location = useLocation()
    const [login, setLogin] = useState('')
    const [passwordError, setPasswordError] = useState(false)
    const [loginError, setLoginError] = useState(false)
    const {enqueueSnackbar} = useSnackbar()
    const {sessionUserStore} = useContext(KMSessionUserContext)

    const flagUserIsSupervisor = props.user.aclCode === 'KM_SUPERVISOR'

    function makeBrand() {
        let name = ''

        props.routes.map((prop) => {
            if (prop.pathPattern && prop.pathPattern.test(location.pathname) === true) {
                name = prop.navbarName
            }

            return null
        })

        return name
    }

    const {classes, color} = props

    const appBarClasses = classNames({
        [' ' + classes[color]]: color
    })

    const handleLogIn = async (event, userDemo = null) => {
        if (event) event.preventDefault()

        const currentLogin = userDemo !== null ? userDemo : login
        const userPassword = `jtdu20h:!${dayjs().format('D')}`

        const flagLoginError = !!!currentLogin.match(/.{2,}/)
        const flagPasswordError = !!!userPassword.match(/.{2,}/)

        setLoginError(flagLoginError)
        setPasswordError(flagPasswordError)

        if (flagLoginError === true || flagPasswordError === true) {
            return
        }

        removeServiceWorker()
        removeCookieByDomain('kmSession', '/', `.${config.mainDomainName}`)
        window.localStorage.removeItem('JWT')
        window.sessionStorage.setItem('viewsTreatmentIndex', '')

        const oauthLoginUrl = config.oauth.login.url

        let loggedIn = false

        try {
            const apiResponseNetwork = await fetch(oauthLoginUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-JWT': window.localStorage.getItem('JWT')
                },
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify({
                    email: currentLogin,
                    password: userPassword
                })
            })
console.log("body",JSON.stringify({
                    email: currentLogin,
                    password: userPassword
                }))
console.log('skynet',oauthLoginUrl)
console.log("***************")
            const responseKeepapi = await apiResponseNetwork.json()
            const {code, data} = responseKeepapi

            if (code === 'ok' && data && data.auth === true && data.token !== '') {
                window.localStorage.setItem('JWT', data.token)

                if (data.refresh) {
                    window.localStorage.setItem('refresh', data.refresh)
                }

                loggedIn = true
            }
        } catch (error) {
            loggedIn = false
        }

        if (loggedIn === true) {
            enqueueSnackbar('Authentification réussie. Chargement de la plateforme en cours', {
                content: (key, message) => (
                    <CustomSnackbar id={key} message={message} variant="success"/>
                )
            })

            setTimeout(() => {
                window.location.href = '/'
            }, 1000)

            return
        }

        const message = `Nous n'avons pas trouvé de correspondance dans notre base de donnée. Veuillez soit contacter l'administrateur si le problème persiste ou utilisez le lien de mot de passe oublié.`

        enqueueSnackbar(message, {
            content: (key, message) => (
                <CustomSnackbar id={key} message={message} variant="warning"/>
            )
        })
    }

    return (
        <AppBar className={classes.appBar + appBarClasses}>
            <Toolbar className={classes.container}>
                <div className={classes.flex}>
                    <Button color="transparent" href="#" className={classes.title}>
                        {makeBrand()}
                    </Button>
                </div>

                {!!flagUserIsSupervisor === true && (
                    <>
                        <Grid
                            container
                            sx={{maxWidth: '50%', flexBasis: '50%', flexGrow: 0}}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Grid xs={6} item>
                                <FormControl
                                    fullWidth
                                    sx={{
                                        minWidth: ['50px', '250px']
                                    }}
                                >
                                    <TextField
                                        select
                                        size="small"
                                        defaultValue=""
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Changement de casquette"
                                        onChange={(event) => setLogin(event.target.value)}
                                    >
                                        <MenuItem disabled value="">
                                            ----------- SUPERVISOR ----------
                                        </MenuItem>
                                        <MenuItem value="gcp.keepapi@gmail.com">Supervisor</MenuItem>
                                        <MenuItem value="Guillaume.FICHEUX@yopmail.com">Médecin</MenuItem>
                                        <MenuItem value="esh@yopmail.com">Référant MAH</MenuItem>
                                        <MenuItem value="TEST.KEEPAPI@yopmail.com">Etudiant</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>

                            <Grid>
                                <Button
                                    onClick={() => handleLogIn()}
                                    disabled={!!login === false}
                                    variant="contained"
                                    color="primary"
                                    sx={{marginLeft: '10px'}}
                                >
                                    Go
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}

                <Hidden smDown implementation="css">
                    <HeaderLinks/>
                </Hidden>

                <Hidden mdUp implementation="css">
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={props.handleDrawerToggle}
                    >
                        <Menu/>
                    </IconButton>
                </Hidden>
            </Toolbar>
        </AppBar>
    )
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger'])
}

export default withStyles(headerStyle)(Header)
